var map = {
	"./badge.svg": 1115,
	"./chat.svg": 1116,
	"./check.svg": 1117,
	"./checked-circle.svg": 1118,
	"./checked-icon.svg": 1119,
	"./checkmark.svg": 1120,
	"./close-fill.svg": 1121,
	"./close-outline.svg": 1122,
	"./close.svg": 1123,
	"./comment.svg": 1124,
	"./comments.svg": 1125,
	"./consultation-deselected.svg": 1126,
	"./dashboard.svg": 1127,
	"./facebook-circle.svg": 1128,
	"./facebook.svg": 1129,
	"./funnel.svg": 1130,
	"./getcall.svg": 1131,
	"./google.svg": 1132,
	"./hide.svg": 1133,
	"./horn.svg": 1134,
	"./loader-spinner.svg": 1135,
	"./lock.svg": 1136,
	"./money-transfer.svg": 1137,
	"./new-projects.svg": 1138,
	"./pending-projects.svg": 1139,
	"./play-active.svg": 1140,
	"./play-inactive.svg": 1141,
	"./projects-in-progress.svg": 1142,
	"./questionmark.svg": 1143,
	"./show.svg": 1144,
	"./stripe.svg": 1145,
	"./support.svg": 1146,
	"./twitter.svg": 1147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1114;